"use client";

import { c as _c } from "react/compiler-runtime";
import React from 'react';
export default function TrustedBrands() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["Google", "Microsoft", "Amazon", "Meta", "Apple", "Netflix", "Tesla", "Adobe", "IBM", "Oracle", "Salesforce", "Shopify", "Spotify", "Uber", "Airbnb"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const brands = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mb-8 text-center"><h3 className="text-lg font-semibold text-gray-600 mb-2">Trusted by Students Hired at</h3></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <section className="py-12 bg-white border-y border-gray-200 overflow-hidden">{t1}<div className="relative"><div className="flex brands-scroll">{[...brands, ...brands].map(_temp)}</div></div></section>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function _temp(brand, index) {
  return <div key={index} className="flex-shrink-0 mx-8 flex items-center justify-center"><span className="text-2xl font-bold text-gray-400 hover:text-[#6059f7] transition-colors whitespace-nowrap">{brand}</span></div>;
}